import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg``;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  width: "33px",
  height: "20px",
  viewBox: "0 0 33 20",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.000000, -10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  width: "24",
  height: "24"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#101010",
  strokeWidth: "3",
  cx: "12.4394433",
  cy: "8.10787506",
  r: "4.60787506"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8788866,21.9894093 C21.8788866,17.0828111 17.6527039,13.1052274 12.4394433,13.1052274 C7.22618271,13.1052274 3,17.0828111 3,21.9894093",
  stroke: "#101010",
  strokeWidth: "3"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.000000, 7.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "0",
  width: "3",
  height: "11"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(5.500000, 5.500000) rotate(-270.000000) translate(-5.500000, -5.500000) ",
  x: "4",
  y: "0",
  width: "3",
  height: "11"
})))))));